<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/main.styl';
</style>
